import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/MobileHome',
    name: 'MobileHome',
    component: () => import('../views/MobileHome.vue'),
    redirect:'MobileMenu',
    children: [
      {
        path: '/MobileProductSearch',
        name: 'MobileProductSearch',
        component: () => import('../views/MobileProductSearch.vue'),
      },{
        path: '/MobileMenu',
        name: 'MobileMenu',
        component: () => import('../views/MobileMenu.vue'),
      },  
      {
        path: '/MobileProductInfo',
        name: 'MobileProductInfo',
        component: () => import('../views/MobileProductInfo.vue'),
      },
      {
        path: '/MobileDataDownload',
        name: 'MobileDataDownload',
        component: () => import('../views/MobileDataDownload.vue'),
      },
      {
        path: '/MobileProgress',
        name: 'MobileProgress',
        component: () => import('../views/MobileProgress.vue'),
      },
      {
        path: '/MobileApprove',
        name: 'MobileApprove',
        component: () => import('../views/MobileApprove.vue'),
      },
      {
        path: '/MobileMeasure',
        name: 'MobileMeasure',
        component: () => import('../views/Measure.vue'),
      },
    ]
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    redirect: 'productCatlogBroswer',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/dashboard.vue'),
      },
      {
        path: '/productCatlog',
        name: 'ProductCatlog',
        component: () => import('../views/productCatlog.vue'),
      },
      {
        path: '/productList',
        name: 'ProductList',
        component: () => import('../views/productList.vue'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/AddProduct',
        name: 'AddProduct',
        component: () => import('../views/AddProduct.vue'),
      },
      {
        path: '/userManage',
        name: 'UserManage',
        component: () => import('../views/userManage.vue'),
      },
      {
        path: '/Log',
        name: 'Log',
        component: () => import('../views/Log.vue'),
      },
      {
        path: '/productSearch',
        name: 'ProductSearch',
        component: () => import('../views/productSearch.vue'),
      },
      {
        path: '/Approve',
        name: 'Approve',
        component: () => import('../views/Approve.vue'),
      },
      {
        path: '/MyApprove',
        name: 'MyApprove',
        component: () => import('../views/MyApprove.vue'),
      },
      {
        path: '/Progress',
        name: 'Progress',
        component: () => import('../views/Progress.vue'),
      },
      {
        path: '/productCatlogBroswer',
        name: 'productCatlogBroswer',
        component: () => import('../views/productCatlogBroswer.vue'),
      },
      {
        path: '/DownloadMenu',
        name: 'DownloadMenu',
        component: () => import('../views/DataDownload/DownloadMenu.vue'),
      },
      {
        path: '/CertView',
        name: 'CertView',
        component: () => import('../views/DataDownload/CertView.vue'),
      },
      {
        path: '/Measure',
        name: 'Measure',
        component: () => import('../views/Measure.vue'),
      },
      {
        path: '/UpdateLog',
        name: 'UpdateLog',
        component: () => import('../views/UpdateLog.vue'),
      },
      {
        path: '/OrderGuide',
        name: 'OrderGuide',
        component: () => import('../views/OrderGuide.vue'),
      },
      {
        path: '/OederReview',
        name: 'OederReview',
        component: () => import('../views/OederReview.vue'),
      },
      {
        path: '/ProductCodeGen',
        name: 'ProductCodeGen',
        component: () => import('../views/ProductCodeGen.vue'),
      },
    ]
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})



export default router
